import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PublicRoutes, initialRoutes } from "./PublicRoutes.js";
import { PrivateRoutes } from "./PrivateRoutes.js";

const publicRoutes = [
  '/',
  '/acessar',
  '/cadastro',
  '/recuperar-senha',
  '/criar-senha',
  '/confirmacao',
  '/senha-funcionario'
];

const AuthenticationWrapper = ({ authenticated, children }) => {
  const location = useLocation();
  const accessToken = localStorage.getItem('access_token');
  const isAuthenticated = authenticated && accessToken;

  useEffect(() => {
    if (!isAuthenticated) {
      const currentPath = location.pathname;
      const isPublicRoute = publicRoutes.includes(currentPath);

      if (!isPublicRoute) {
        const redirectPath = location.pathname + location.search;
        localStorage.setItem('redirectAfterLogin', redirectPath);
      }
    }
  }, [location, isAuthenticated]);

  return children;
};

const authentication = (authenticated) => {
  const accessToken = localStorage.getItem('access_token');
  const isAuthenticated = authenticated && accessToken;

  return (
    <AuthenticationWrapper authenticated={authenticated}>
      {isAuthenticated ? <PrivateRoutes /> : <PublicRoutes />}
    </AuthenticationWrapper>
  );
};

export default authentication;
